// src/pages/CompetitionDetails.jsx
import React from "react";
import "./CompetitionDetails.scss";

const CompetitionDetails = () => {
  return (
    <div className="container main-content competition-details">
      <div className="row gy-4">
        <div className="col-md-3 d-flex">
          <Section icon="bi bi-info-circle-fill" title="Információk">
            <p>
              <span className="fw-bold">Helyszín:</span> Várfölde,
              Szabadidő Központ
            </p>
            <p>
              <span className="fw-bold">Időpont:</span> 2025. július 12.
              (szombat)
            </p>
            <p>
              <span className="fw-bold">Kezdés:</span> 8:30
            </p>
          </Section>
        </div>

        <div className="col-md-6 d-flex">
          <Section icon="bi bi-person-check-fill" title="Nevezési feltételek">
            <p>
              <span className="fw-bold">Nevezési határidő:</span> 2025. július
              04.
            </p>
            <p>
              <span className="fw-bold">Nevezési díj:</span> 18 000 Ft/csapat
            </p>
            <p>
              <span className="fw-bold">Nevezhető csapattagok száma:</span> max
              11 fő.
            </p>
            <p>
              <span className="fw-bold">Résztvevő csapatok száma:</span> max 16
              csapat.
            </p>
          </Section>
        </div>

        <div className="col-md-3 d-flex">
          <Section icon="bi bi-award-fill" title="Díjazás">
            <p>
              <span className="fw-bold">I. hely:</span> Vándorkupa, kupa, 45 000
              Ft-os RECOP vásárlási utalvány
            </p>
            <p>
              <span className="fw-bold">II. hely:</span> kupa, 35 000 Ft-os
              RECOP vásárlási utalvány
            </p>
            <p>
              <span className="fw-bold">III. hely:</span> kupa, 30 000 Ft-os
              RECOP vásárlási utalvány
            </p>
            <span className="fw-bold">Különdíjak:</span> gólkirály, legjobb
            kapus, legjobb játékos, legsportszerűbb csapat
          </Section>
        </div>

        <div className="col-md-12 offset-md d-flex">
          <Section icon="bi bi-clipboard-check-fill" title="Játékszabályok">
            <div className="accordion" id="rulesAccordion">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    Játékidő és lebonyolítás
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#rulesAccordion"
                >
                  <div className="accordion-body">
                    <p>A benevezett 16 csapat 4 db 4-es csoportban közmérkőzést játszik 2 x 12 perc játékidővel.</p>
                    <p>A csapatokból az 1. és 2. helyezettek jutnak tovább, ahol egyenes kieséses rendszerben jutnak el a döntőig.</p>
                    <p>A negyeddöntőktől a játékidő 2 x 15 percre módosul.</p>
                    <p className="fst-italic">
                      Rendkívüli időjárási viszonyok miatt (hőség, esős idő) a mérkőzések játékideje a csapatok és játékvezetők
                      kölcsönös beleegyezésével módosulhat.
                    </p>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwo">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    Helyezések eldöntése
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#rulesAccordion"
                >
                  <div className="accordion-body">
                    <ol>
                      <li>Megszerzett pontok (győzelem 3, döntetlen 1, vereség 0)</li>
                      <li>Egymás ellen elért eredmény</li>
                      <li>Gólkülönbség</li>
                      <li>Több rúgott gól</li>
                      <li>Amennyiben az 1-4 pontok alapján nem dönthető el a továbbjutás, a csapatok 7 m-es rúgásokkal döntik el azt.
                        (Csapatonként 3-3 7 m-es rúgás, ha ez sem dönt, akkor a csapatok felváltva rúgnak büntetőt mindaddig, amíg a továbbjutás el nem dől.</li>
                    </ol>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="headingThree">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    Felszerelés
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#rulesAccordion"
                >
                  <div className="accordion-body">
                    <p>Pályára szabályos szerelésben lehet lépni (lehetőség szerint egyszínű mez vagy póló, nadrág, cipő , <span className="fst-italic">sípcsontvédő használatas</span>)</p>
                      <p>Cipő típusa:</p>
                      <ul>
                      <li>sportcipő</li>
                      <li>terem (IC)</li>
                      <li>műfüves (TF) cipők</li>
                      <li>stoplis</li>
                      <li className="fw-bold">éles stoplis <span className="text-decoration-underline">NEM</span> használható!</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFour">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    Egyéb szabályok
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#rulesAccordion"
                >
                  <div className="accordion-body">
                   <p>Becsúszó szerelés <span className="text-decoration-underline fw-bold">NEM</span> megengedett!</p>
                   <p>
                    Kiállítás: 2, 5 perc és végleges lehet
                    A véglegesen kiállított játékos a soron következő fordulóban nem szerepelhet. A véglegesen kiállított játékos helyére 5 perc elteltével
                    léphet pályára más játékos
                   </p>
                  </div>
                </div>
              </div>
            </div>
          </Section>
        </div>
      </div>
    </div>
  );
};

const Section = ({ title, children, icon, fullHeight }) => (
  <div
    className={`info-section w-100 d-flex flex-column ${
      fullHeight ? "h-100" : ""
    }`}
  >
    <h2 className="section-title mb-3">
      {icon && <i className={`${icon} me-2`}></i>}
      {title}
    </h2>
    <div className="section-content p-3 rounded border flex-grow-1">
      {children}
    </div>
  </div>
);

export default CompetitionDetails;
